import { Route } from 'react-router-dom';
import CSVUpload from './components/pageComponents/CSVUpload/CSVUpload';
import ServiceRequestUpload from './components/pageComponents/SRUpload/ServiceRequestUpload';
import OfficePracticum from './components/pageComponents/OfficePracticum/OfficePracticum';
import FormCondition from './components/pageComponents/SuperAdmin/FormConditions/FormsCondition';
import { AddOrganizationPage } from './components/pageComponents/SuperAdmin/Organization/AddOrganizationPage';
import { EditOrganizationPage } from './components/pageComponents/SuperAdmin/Organization/EditOrganization';
import Prompts from './components/pageComponents/SuperAdmin/Prompts/Prompts';
import SuperAdmin from './components/pageComponents/SuperAdmin/SuperAdmin';
import Templates from './components/pageComponents/Templates/Templates';
import HumanScribe from './components/pageComponents/SuperAdmin/HumanScribe/HumanScripe';
import AiComponents from './components/pageComponents/SuperAdmin/AI/Ai';
import Agents from './components/pageComponents/SuperAdmin/Agents/ListAgents';
import EHRAppointmentTypeMappingPage from './components/pageComponents/EHRSettings/EHRAppointmentTypeMapping.page';
import NotificationTemplateOverridesPage from './components/pageComponents/SuperAdmin/NotificationTemplates/NotificationTemplateOverrides.page';
import FaxPage from './components/pageComponents/SuperAdmin/Fax/Fax.page';
import EHRIntegrations from './components/pageComponents/EHRIntegrations/EHRIntegrations';
import DataRetentionPage from './components/pageComponents/SuperAdmin/DataRetention/DataRetention.page';
import MagicFlowAdminPage from './components/pageComponents/SuperAdmin/MagicFlow/MagicFlowAdmin.page';
import MagicFlowFlowEditorPage from './components/pageComponents/SuperAdmin/MagicFlow/MagicFlowFlowEditor.page';
import MagicFlowRecipeEditorPage from './components/pageComponents/SuperAdmin/MagicFlow/MagicFlowRecipeEditor.page';
import SchedulingRulesPage from './components/pageComponents/SuperAdmin/SchedulingRules/SchedulingRules.page';

export const getSuperAdminRoutes = () => {
  const pages = [
    {
      path: '/superadmin',
      Component: SuperAdmin,
    },
    {
      path: '/superadmin/addOrganization',
      Component: AddOrganizationPage,
    },
    {
      path: '/superadmin/editOrganization',
      Component: EditOrganizationPage,
    },
    {
      path: '/superadmin/csvupload',
      Component: CSVUpload,
    },
    {
      path: '/superadmin/sr-upload',
      Component: ServiceRequestUpload,
    },
    {
      path: '/superadmin/prompts',
      Component: Prompts,
    },
    {
      path: '/superadmin/ai',
      Component: AiComponents,
    },
    {
      path: '/superadmin/agents',
      Component: Agents,
    },
    {
      path: '/superadmin/formconditions',
      Component: FormCondition,
    },
    {
      path: '/superadmin/templates',
      Component: Templates,
    },
    {
      path: '/superadmin/notification-templates',
      Component: NotificationTemplateOverridesPage,
    },
    {
      path: '/superadmin/humanScribe',
      Component: HumanScribe,
    },
    {
      path: '/superadmin/officepracticum',
      Component: OfficePracticum,
    },
    {
      path: '/superadmin/ehr-appointment-type-mapping',
      Component: EHRAppointmentTypeMappingPage,
    },
    {
      path: '/superadmin/fax',
      Component: FaxPage,
    },
    {
      path: '/superadmin/ehr-integrations',
      Component: EHRIntegrations,
    },
    {
      path: '/superadmin/data-retention',
      Component: DataRetentionPage,
    },
    {
      path: '/superadmin/magicflow',
      Component: MagicFlowAdminPage,
    },
    {
      path: '/superadmin/magicflow/recipes',
      Component: MagicFlowAdminPage,
    },
    {
      path: '/superadmin/magicflow/flows',
      Component: MagicFlowAdminPage,
    },
    {
      path: '/superadmin/magicflow/flow-runs',
      Component: MagicFlowAdminPage,
    },
    {
      path: '/superadmin/magicflow/events',
      Component: MagicFlowAdminPage,
    },
    {
      path: '/superadmin/magicflow/debugger',
      Component: MagicFlowAdminPage,
    },
    {
      path: '/superadmin/magicflow/recipes/new',
      Component: MagicFlowRecipeEditorPage,
    },
    {
      path: '/superadmin/magicflow/recipes/:recipeId',
      Component: MagicFlowRecipeEditorPage,
    },
    {
      path: '/superadmin/magicflow/flows/new',
      Component: MagicFlowFlowEditorPage,
    },
    {
      path: '/superadmin/magicflow/flows/:flowId',
      Component: MagicFlowFlowEditorPage,
    },
    {
      path: '/superadmin/scheduling-rules',
      Component: SchedulingRulesPage,
    },
  ];

  return pages.map((route, index) => {
    const { path, Component } = route;
    return <Route key={index} path={path} element={<Component />} />;
  });
};
